import { CreateResource, createApiResource } from '../apiResourceFactory';
import { API } from '../apiService';

import type { ServiceTitanApiPhoneCallCreateDTO, PhoneCallDetailDTO } from '../apiTypes.shim';

interface ServiceTitanApiPhoneCallResource
  extends CreateResource<ServiceTitanApiPhoneCallCreateDTO, PhoneCallDetailDTO> {}

export const createServiceTitanApiPhoneCallResource = (): ServiceTitanApiPhoneCallResource => {
  const phoneCallUri = `v2/phone-calls`;
  const { create, useCreate } = createApiResource(API, phoneCallUri);
  return { create, useCreate };
};
